const DARK_API = '2d5d6260b113b4e9144ed3d7ca038035'

const MAP_API = 'AIzaSyCjL1-zsMNGVKO46dM2K1ZPuMyqPpzvcPE'


export { DARK_API, MAP_API }  

// https://locationiq.com/ - mozliwe api do mapy